import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MdArrowForwardIos } from "react-icons/md";
import { RxCross2 } from "react-icons/rx";

export function CartItem({book, setData}) {
  const [showInfo, setShowInfo] = useState()
  const navigate = useNavigate()
  const infoRef = useRef(null)

  return (
    <div className="relative flex h-full gap-x-2 sm:gap-x-5 font-medium cursor-pointer" onClick={() => setShowInfo(!showInfo)}>
      <div className="shrink-0 bookImage aspect-square w-16 sm:w-20 md:w-24 h-full bg-neutral-100">
        <img src={`https://firebasestorage.googleapis.com/v0/b/bolig2.appspot.com/o/${book.dbBook['_id']}%2F0?alt=media`} alt='BOOK' className="m-auto w-full h-full object-contain bg-neutral-100" />
      </div>
      <div className="bookInfo">
        <div className="praktisk flex flex-col gap-2 text-sm xl:text-base">
          <div className="">
            <h1 className="font-semibold">{book.apiBook.title}</h1>
            <p className="font-medium">{Number(book.dbBook.price/100).toFixed(2).toString().replace(/\./g, ',')} kr.</p>
          </div>
          <div className="text-sm flex gap-1 items-center">
            Se info
            <MdArrowForwardIos className={`transition-[] ${showInfo ? "rotate-90" : ""}`} />
          </div>
          <div ref={infoRef}
            className="overflow-hidden transition-max-height duration-300 ease-in-out"
            style={{ maxHeight: showInfo ? `${infoRef.current?.scrollHeight}px` : "0" }}>
            <p className="text-gray-700 font-medium">Udgave: <span className="font-normal">{book.apiBook.version}</span></p>
            <p className="text-sm lg:text-base text-gray-700 font-medium">Forfatter:
              {(typeof book.apiBook.director !== 'undefined') ? 
                book.apiBook.director.length > 0 ?
                  <span className="italic font-normal">
                      {book.apiBook.director.map((dir, index) => {
                        if (index !== 0) {
                            return `, ${dir['$']}`
                        } else {
                            return ` ${dir['$']}`
                        }
                      })}
                  </span>
                :
                  <span className="font-normal"> Ukendt forfatter</span>
              :
                " Loading..."}
            </p>
            <p className="text-sm lg:text-base text-gray-700 font-medium">ISBN:
              <span className="font-normal">
                {(typeof book.apiBook.isbn !== 'undefined') ? 
                  " " + book.apiBook.isbn
                : "Loading..."}
              </span>
            </p>
            <div className="flex gap-2 items-center relative">
              <p className="text-xs lg:text-sm font-semibold uppercase">{book.dbBook.stand === 1 ? "Meget brugt" : book.dbBook.stand === 2 ? "Lettere brugt" : "Som ny"}</p>
              <div className="flex group md:relative flex-wrap-reverse" tabindex="0">
                <div className="q-mark cursor-pointer group-focus:text-gray-500">
                  <svg class="w-4 h-4 text-gray-400 hover:text-gray-500" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd"></path></svg><span class="sr-only">Show information</span>
                </div>
                <div className="">
                  <div class="q-text left-0 invisible opacity-0 group-hover:visible group-hover:opacity-100 group-focus:visible group-focus:opacity-100 absolute bottom-[25px] z-10 w-64 text-sm transition-opacity duration-100 bg-white border border-gray-200 shadow-sm">
                    <div class="px-3 py-2 bg-gray-100 border-b border-gray-200 rounded-t-lg dark:border-gray-600 dark:bg-gray-700">
                        <h3 class="font-semibold text-gray-900 dark:text-white">Stand</h3>
                    </div>
                    <div class="px-3 py-2 flex flex-col gap-2">
                      <p>Denne bog er vurderet som <span className="uppercase font-medium">{(book.dbBook.stand === 1) ? "Meget brugt" : (book.dbBook.stand === 2) ? "Lettere brugt" : "Som ny"}</span>, hvilket betyder:</p>
                      <p>{(book.dbBook.stand === 1) ? "Tydelige slidtegn, krøllet omslag, muligvis noter og pletter. Alle sider intakte." : (book.dbBook.stand === 2) ? "Mindre tegn på brug, bøjede hjørner, muligvis enkelte noter. God stand." : "Næsten ubrugt, ingen synlige slidtegn eller markeringer. Perfekt stand."}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="absolute right-0 top-0"><RxCross2 className="hover:underline cursor-pointer font-medium" onClick={() => localStorage.setItem('basket', localStorage.getItem('basket').split(',').filter(id => id !== book.dbBook._id).join(',')) & setData(prev => prev.filter(bog => bog.dbBook._id !== book.dbBook._id))} /></div>
    </div>
  )
}